import React, { useState } from "react";
import { Redirect } from "react-router";

import SearchParishesContainer from "../components/search-parish/SearchParishesContainer";
import SearchParishesController from "../components/search-parish/SearchParishesController";
import IParishFilters from "../data/parish/ParishFilters";
import IParishMin from "../data/parish/ParishMin";
import useFetchData from "../requests/useFetchData";
import PageWrapperTwoColumns from "./PageWrapperTwoColumns";

const SearchParishesPage: React.FC = () => {
    const params = new URLSearchParams(window.location.search);

    const initCurrentPage: number = Number(params.get("page")) || 1;
    const [currentPage, setCurrentPage] = useState(initCurrentPage);
    const resetPagination = () => {
        setCurrentPage(1);
    };

    const initParishName: string = params.get("name") || "";
    const initCityName: string = params.get("cityName") || "";
    const initMinSize: string = params.get("minSize") || "";
    const initFullTextSearch: string = params.get("fullTextSearch") || "";
    const initVerifiedProfile: string = params.get("verifiedProfile") || "";
    const initFilters: IParishFilters = {
        parishName: initParishName,
        cityName: initCityName,
        minSize: initMinSize,
        fullTextSearch: initFullTextSearch,
        verifiedProfile: initVerifiedProfile
    };
    const [filters, setFilters] = useState(initFilters);

    const filterURL = Object.entries(filters).reduce((prev: string, entry: [string, string]) => {
        if (entry[1] === "") {
            return prev;
        } else {
            return prev + entry[0] + "=" + encodeURIComponent(entry[1]) + "&";
        }
    }, "");

    const [isListView, setIsListView] = useState(false);
    const toggleMap = () => setIsListView((prevState) => !prevState);

    const { response, loading, showError } = useFetchData<IParishMin[]>(`/parishes?${filterURL}`);

    return (
        <>
            <Redirect to={`/parishes/search?${filterURL}page=${currentPage}`} />
            <PageWrapperTwoColumns>
                <SearchParishesController
                    filters={filters}
                    isListView={isListView}
                    resetPagination={resetPagination}
                    setFilters={setFilters}
                    toggleMap={toggleMap}
                />
                <SearchParishesContainer
                    currentPage={currentPage}
                    isListView={isListView}
                    loading={loading}
                    parishes={response}
                    setCurrentPage={setCurrentPage}
                    showError={showError}
                />
            </PageWrapperTwoColumns>
        </>
    );
};

export default SearchParishesPage;
